import { BaseApi } from '@/main/baseApi';

import { DMS_MODULE, NAME } from './constants';

export const vydejkaTisk = '/Reports/Reports/GetVydejkaNDReport';
export const reservePartTisk = '/Reports/Reports/GetReserveSPReport';

class VydejkaProvider extends BaseApi {
	getVydejkaNDReport(id: number) {
		return this.fetchReport('GetVydejkaNDReport', { id });
	}
}
export const apiProvider = new VydejkaProvider(DMS_MODULE, NAME);
